import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {CHARCOAL} from '../../../shared/style/colors';
import {DESKTOP, LAPTOP, MEDIUM, PHONE} from '../../../shared/style/breakpoints';
import {FONTS, WEIGHT} from '../../../shared/style/typography';
import {MAX_PAGE_WIDTH} from '../../../shared/style/dimensions';

const customStyling = {
  display: 'flex',
  height: 80,
  [DESKTOP]: {
    width: '17%'
  },
  [LAPTOP]: {
    width: '16%'
  },
  [PHONE]: {
    width: '45%'
  }
};

const Title = glamorous.div({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  minHeight: 78,
  fontSize: 30,
  fontWeight: WEIGHT.ULTRA_BLACK,
  lineHeight: '44px',
  textAlign: 'center',
  color: CHARCOAL,
  maxWidth: MAX_PAGE_WIDTH,
  margin: 'auto',
  marginBottom: 20,
  [PHONE]: {
    fontSize: 24,
    lineHeight: '40px',
    marginBottom: 30
  }
});

const IconContainer = glamorous.div({
  textAlign: 'center',
  maxWidth: MAX_PAGE_WIDTH,
  margin: 'auto',
  marginBottom: 85,
  padding: '0 20px',
  [PHONE]: {
    display: 'flex',
    overflow: 'scroll',
    '::-webkit-scrollbar': {
      width: 0
    }
  },
  [MEDIUM]: {
    display: 'flex',
    overflow: 'scroll',
    '::-webkit-scrollbar': {
      width: 0
    }
  }
});

const IconSubContainer = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  margin: 'auto',
  justifyItems: 'center',
  gap: 30,
  alignItems: 'center',
  [PHONE]: {
    gap: 25
  }
});

const Images = glamorous.img(({customStyle}) => (customStyle ? customStyle : {}));

const features = [
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/cbre.svg',
    customStyle: customStyling
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/cox.svg',
    customStyle: customStyling
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/moodys.svg',
    customStyle: customStyling
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/coke_consolidated.svg',
    customStyle: customStyling
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/tyler.svg',
    customStyle: customStyling
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/allegro.svg',
    customStyle: {...customStyling, [DESKTOP]: {...customStyling[DESKTOP], margin: '0 10px'}}
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/xactly.svg',
    customStyle: {...customStyling, [DESKTOP]: {...customStyling[DESKTOP], margin: '0 10px'}}
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/awin.svg',
    customStyle: {
      ...customStyling,
      [DESKTOP]: {...customStyling[DESKTOP], margin: '-20px 10px 0 10px'},
      [LAPTOP]: {...customStyling[LAPTOP], marginTop: -15},
      [PHONE]: {...customStyling[PHONE], marginTop: -20}
    }
  },
  {
    icon: 'https://img.stackshare.io/fe/companies_logos/navex.svg',
    customStyle: {...customStyling, [DESKTOP]: {...customStyling[DESKTOP], margin: '0 10px'}}
  }
];

const CompaniesUsingStackshare = ({title}) => {
  return (
    <>
      <Title>{title}</Title>
      <IconContainer>
        <IconSubContainer>
          {features.map((item, index) => (
            <Images key={index} src={item.icon} customStyle={item.customStyle} />
          ))}
        </IconSubContainer>
      </IconContainer>
    </>
  );
};

CompaniesUsingStackshare.propTypes = {
  title: PropTypes.string
};

export default CompaniesUsingStackshare;
